<template>
  <v-container class="pa-6">
    <v-row justify="center" align="center">
      <v-col cols="12">
        <div class="collectiblesTitle">Drops</div>
        <div class="collectiblesSubtitle">
          Check out GOLDEN MOMENT's latest drop collection, featuring unique and
          carefully designed digital collectibles.
        </div>
      </v-col>

      <v-col cols="12">
        <v-card-actions class="ma-0 pa-0" style="margin-top: 20px;">
          <v-btn
            depressed
            text
            class="tabButton"
            :class="selectedTab === 0 ? 'selectedTabButton' : ''"
            @click="$emit(`selectTab`, 0)"
          >
            <div class="condensedTabText">
              Overview
            </div>
          </v-btn>
          <v-btn
            depressed
            text
            class="tabButton"
            :class="selectedTab === 1 ? 'selectedTabButton' : ''"
            @click="$emit(`selectTab`, 1)"
          >
            <div class="condensedTabText">
              Available
            </div>
          </v-btn>
          <v-btn
            depressed
            text
            class="tabButton"
            :class="selectedTab === 2 ? 'selectedTabButton' : ''"
            @click="$emit(`selectTab`, 2)"
          >
            <div class="condensedTabText">
              Past Drops
            </div>
          </v-btn>
        </v-card-actions>
      </v-col>

      <v-col cols="12" style="margin-top: -32px;">
        <template v-for="(collectible, index) in collectibles">
          <div :key="index" class="collectibleBox">
            <div style="margin: -3px;">
              <v-img
                class="image"
                :src="
                  collectible.isPremium
                    ? collectible.premium.bannerUrl
                    : collectible.bannerUrl
                "
                eager
                cover
              />
            </div>

            <v-row no-gutters justify="center" align="center">
              <v-col cols="12" style="padding: 24px;">
                <div class="collectibleArtist">
                  {{ collectible.artist }}
                </div>
                <div class="collectibleName">
                  {{
                    collectible.isPremium
                      ? collectible.premium.name
                      : collectible.name
                  }}
                </div>
                <div class="collectibleDescription" style="margin-top: 16px;">
                  {{
                    collectible.isPremium
                      ? collectible.premium.description
                      : collectible.description
                  }}
                </div>
                <div v-if="selectedTab !== 2">
                  <div class="collectibleInstruction" style="margin-top: 16px;">
                    {{
                      collectible.isPremium
                        ? collectible.premium.instruction
                        : collectible.instruction
                    }}
                  </div>
                  <div
                    v-if="
                      $moment(collectible.startDate) < Date.now() &&
                        !collectible.isPremium
                    "
                    class="collectibleQuantity"
                    style="margin-top: 16px;"
                  >
                    Remaining
                    {{
                      collectible.dailyFreeQuantity - collectible.claimedCount
                    }}
                    / {{ collectible.dailyFreeQuantity }}
                  </div>
                  <div
                    v-if="$moment(collectible.startDate) < Date.now()"
                    style="margin-top: 16px;"
                  >
                    <v-btn
                      v-if="collectible.isPremium"
                      depressed
                      block
                      class="yellowButton"
                      @click="
                        $router.push(
                          `/drops/${collectible.collectibleId}/premium`
                        )
                      "
                    >
                      Buy Now
                      <v-icon
                        style="margin-left: 16px; width: 20px; height: 20px;"
                      >
                        mdi-arrow-right
                      </v-icon>
                    </v-btn>
                    <v-btn
                      v-else
                      depressed
                      block
                      class="yellowButton"
                      @click="
                        $router.push(`/drops/${collectible.collectibleId}`)
                      "
                    >
                      Free Pack
                      <v-icon
                        style="margin-left: 16px; width: 20px; height: 20px;"
                      >
                        mdi-arrow-right
                      </v-icon>
                    </v-btn>
                  </div>
                  <div v-else style="margin-top: 16px;">
                    <v-btn depressed block class="yellowButton" disabled>
                      Available Soon
                    </v-btn>
                  </div>
                </div>
                <div v-else>
                  <div class="collectibleQuantity" style="margin-top: 16px;">
                    Sold Out
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    props: ['collectibles', 'selectedTab'],
  };
</script>

<style scoped>
  .tabButton {
    font-size: 16px !important;
    height: 48px !important;
    width: 120px !important;
  }
  .collectibleBox {
    margin-top: 32px;
    margin-bottom: 32px;
    box-sizing: border-box;
    background: rgba(235, 235, 235, 0.3);
    border-radius: 30px;
    border: 3px solid var(--colour-system-2-shade-shade-100, #c0c0c0);
  }
  .collectiblesTitle {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 36px !important;
    line-height: 42px !important;
    color: #1c1c1c;
  }
  .collectiblesSubtitle {
    margin-top: 16px;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    letter-spacing: 0.003em !important;
    color: #1c1c1c;
  }

  .image {
    width: 100% !important;
    height: 100% !important;
    border-radius: 30px 30px 0px 0px;
  }

  .collectibleArtist {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    color: #151515 !important;
  }

  .collectibleName {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 24px !important;
    line-height: 32px !important;
    color: #151515 !important;
  }
  .collectibleDescription {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    letter-spacing: 0.003em !important;
    color: #151515 !important;
  }

  .collectibleInstruction {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 22px !important;
    color: #151515 !important;
    white-space: pre-line;
  }

  .collectibleQuantity {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    color: #151515 !important;
  }

  .timerTitle {
    width: 100%;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 45px !important;
    line-height: 52px !important;
    color: #151515 !important;
    text-align: center;
  }

  .timerLabel {
    width: 100%;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #151515 !important;
    text-align: center;
  }

  .collectibleButton {
    height: 56px !important;
    background: #151515 !important;
    border-radius: 30px !important;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 20px !important;
  }

  .condensedTabText {
    margin-left: -16px;
    margin-right: -16px;
  }
</style>
